// Module
var code = "<div ng-controller=\"documentation-controller\">\n    <iframe class=\"iframe-doc\" ng-src=\"{{iframeUrl}}\" width=\"100%\"  frameborder=\"0\"></iframe>\n</div>\n";
// Exports
module.exports = code;